// Shared "is this path EN-only?" rules used by Layout.js (lang/hreflang/redirect)
// and SEO/index.js (og:locale alternates). Single source of truth so the two
// can't drift.

export const LEGAL_PATHS = new Set([
  "/terms/",
  "/privacy/",
  "/content-policy/",
  "/cookie-policy/",
  "/referral-program-agreement/",
])

// Ensure trailing slash so `/privacy` and `/privacy/` both match LEGAL_PATHS.
// Gatsby normalises URLs to trailing-slash, but bookmarks / external links may
// omit it — fail safe rather than silently flipping to multilingual behaviour.
export const normalizePathname = (p) => (p.endsWith("/") ? p : `${p}/`)

export const isLegalPath = (pathname) => LEGAL_PATHS.has(normalizePathname(pathname))

export const isEnOnlyPath = (pathname) =>
  pathname.startsWith("/blog") || isLegalPath(pathname)
